export default __webpack_public_path__ + "static/media/hero-video-mobile-pt.b19db3a5.webm";